import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSearchParamsToObject } from '../../Services/helpers';
import {liveSearch} from './liveSearch';

const SearchContext = createContext();

export const useSearchContext = () => {
    return useContext(SearchContext);
};

let debounce = null;

export const Provider = ({ children, onChange, data, hasConditionsFilter, debounceTime = 300 }) => {
    const [searchData, setSearchData] = useState(data ?? {});
    const [searchDebounced, setSearchDebounced] = useState(data ?? {});
    const [hasSearchConditions, setHasSearchConditions] = useState(false);
    // Pull in search criteria from URL
    const [searchParams] = useSearchParams();
    useSearchParamsToObject(searchParams, setSearchData);

    useEffect(() => {
        onChange && onChange(searchData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData]);

    useEffect(() => {
        if (debounce) {
            clearTimeout(debounce);
        }
        debounce = setTimeout(() => {
            setSearchDebounced(searchData);
        }, debounceTime);

        updateHasSearchConditions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData]);

    const setSearchField = (field, value) => {
        setSearchData({
            ...searchData,
            [field]: value,
        });
    }

    const updateHasSearchConditions = () => {
        let _searchData = hasConditionsFilter ? hasConditionsFilter(searchData) : searchData;

        if (typeof _searchData === 'boolean') {
            setHasSearchConditions(_searchData);
            return;
        }

        const filtered = Object.values(_searchData).filter(v => v !== null && v !== undefined && v !== '');

        setHasSearchConditions(filtered.length > 0);
    }

    const providerValues = {
        searchData,
        searchDebounced,
        setSearchData,
        setSearchField,
        hasSearchConditions,
        hasConditionsFilter,
        liveSearch: liveSearch(searchData?.search),
        hasActiveSearch: Object.keys(searchData).filter(v => !!v).length > 0,
    };

    return (
        <SearchContext.Provider value={providerValues}>
            {children}
        </SearchContext.Provider>
    );
};
